<template>
    <div class="app-container">
      <el-row class="headTop">
        <el-col :span="2">
          <el-button
            class="goBack"
            style="width:150px"
            @click="goback()"
          >返回上一级</el-button>
        </el-col>
        <el-col :span="2" :offset="20">
          <el-button style="width:100%" type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
        </el-col>
      </el-row>
    <el-dialog title="退票配置"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="150px">
          <!-- <el-form-item label="时间类型" prop="timetype">
            <el-select v-model="formparams.timetype"
              placeholder="请选择"
            >
              <el-option v-for="item in this.timetypes"
              :key="item.value"
              :label="item.lable"
              :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
          
          <!-- <el-form-item label="提前可预约时长" prop="appointmenttime">
            <el-input v-model="formparams.appointmenttime" placeholder="请输入提前可预约时长"></el-input>
          </el-form-item> -->
          <el-form-item label="退票时间类型" prop="cancleTimeType">
            <el-select v-model="formparams.cancleTimeType"
              placeholder="请选择"
            >
              <el-option v-for="item in this.timetypes"
              :key="item.value"
              :label="item.lable"
              :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="退票时长" prop="canceltime">
            <el-input class="w220" v-model.number="formparams.canceltime" placeholder="请输入取消预约时长"></el-input>
          </el-form-item>
          <el-form-item label="是否审批">
            <el-switch
              v-model="formparams.ifApprove"
              active-value= '1'
              inactive-value= '0'
              active-text="是"
              inactive-text="否">
            </el-switch>
          </el-form-item>
          <el-form-item label="退款百分比" prop="refundPercentage">
            <el-input class="w220" v-model.number="formparams.refundPercentage" maxlength="3" placeholder="请输入退款百分比(1-100)"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <!-- <el-table-column prop="appointmenttime" label="提前预约时间"></el-table-column> -->
        <!-- <el-table-column label="提前预约时间">
          <template slot-scope="scope">
            <div>
              <span>{{scope.row.appointmenttime}}</span>
              <span v-if="scope.row.cancleTimeType==0">天</span>
              <span v-if="scope.row.cancleTimeType==1">小时</span>
              <span v-if="scope.row.cancleTimeType==2">分钟</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="票名称">
          <template>
            <div>{{name}} </div>
          </template>
        </el-table-column>
        <el-table-column label="取消预约时间">
          <template slot-scope="scope">
            <div>
              <span>{{scope.row.canceltime}}</span>
              <span v-if="scope.row.cancleTimeType==0">天</span>
              <span v-if="scope.row.cancleTimeType==1">小时</span>
              <span v-if="scope.row.cancleTimeType==2">分钟</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="场馆">
          <template slot-scope="scope">
            <div> {{scope.row.shopnum|caseType}} </div>
          </template>
        </el-table-column>
        <el-table-column label="退款百分比">
          <template slot-scope="scope">
            <div> {{scope.row.refundPercentage}} </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button style="width:100px"  type="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination" style="display:none">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {ticketGetTbAppointConfig, deleteTbAppointConfig, tickeTinsertTbAppointConfig, tickeTupdateTbAppointConfig, placegetInfI, getShops } from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      addType:1,
      name:this.$route.query.name,
      timetypes:[
        {lable:'天',value:0},
        {lable:'小时',value:1},
        {lable:'分钟',value:2}
      ],
      date:[],//开始时间结束时间
      rules:{
        // appointmenttime:[
        //   { required: true, message: '请输入提前预约时长', trigger: 'blur' }
        // ],
        timetype:[
          { required: true, message: '请选择时间类型', trigger: 'change' }
        ],
        canceltime:[
          // { required: true, message: '请输入取消预约时长', trigger: 'blur' },
          { required: true, message: '请输入取消预约时长', trigger: 'blur' },
          { type: 'number', min:1, message: '取消预约时长必须大于0的数字'}
        ],
        cancleTimeType:[
          { required: true, message: '请选择时间类型', trigger: 'change' }
        ],
        refundPercentage:[
          { required: true, message: '请输入1-100的数字', trigger: 'blur' },
          { type: 'number', min:1,max:100, message: '百分比必须1-100的数字'}
        ],
      },
      startTime:'',
      endTime:'',
      timeList:[],
      addType:1,
      formparams:{
        // appointmenttime:'',
        canceltime:'',
        // timetype:'',
        cancleTimeType:'',
        refundPercentage:'',
        ifApprove: '0',
        type:this.$route.query.type,
        shortName:this.$route.query.shortName,
        shopNum:this.$route.query.shopNum,
      },
      formData:{},
      fileList:[],//图片回显示
      tableData:[],
      options:[],//票类型
      optionsJL:[],//私教列表
      classProject:[],//团课项目
      roomList:[],
      titleList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    },
    className(value) {
      console.log(value)
      console.log(that.options)
      if (that.options.find(i => {
        return i.itemstyle == value
        })) {
        return that.options.find(i => {
            return i.itemstyle == value
        }).name
      }
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
    this.placegetInfI()
    this.shopListAll =  JSON.parse(sessionStorage.getItem('shopList'))
    if(sessionStorage.getItem('shopList')){
      this.shopList = JSON.parse(sessionStorage.getItem('shopList'))
      for (let i = 0; i < this.shopList.length; i++) {
        this.titleList.push({value:this.shopList[i].shopNum,text:this.shopList[i].name})
      }
    } else{
      this.getShopsList()
    }
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    goback(){
      // this.$router.go(-1)
      this.$router.push({name:'buyTicket',query:{queryParams:this.$route.query.queryParams}})
    },
    placegetInfI(){
      placegetInfI().then((res)=>{
        // console.log(res)
        this.classProject = res.data
      })
    },
    getShopsList(){
      getShops().then((res)=>{
        this.shopList = res.data
        for (let i = 0; i < this.shopList.length; i++) {
          this.titleList.push({value:this.shopList[i].shopNum,text:this.shopList[i].name})
        }
        sessionStorage.setItem('shopList',JSON.stringify(res.data))
      })
    },
    getTableList(){
      ticketGetTbAppointConfig({shortName:this.$route.query.shortName,type:this.$route.query.type,shopNum:this.$route.query.shopNum,}).then((res)=>{
        console.log(res)
        if(res.msg == "success"){
            this.tableData = res.data
        }
        this.loading = false
      })
    },
    showDialog(){
        this.dialogVisible =true
        this.addType = 1
        this.formparams.canceltime = ''
        this.formparams.cancleTimeType = ''
        this.formparams.refundPercentage = ''
        this.formparams.ifApprove = '0'
    },
    //编辑
    edit(row){
      this.addType = 2
      console.log(row)
      this.dialogVisible = true
      this.formparams.id = row.id
      // this.formparams.appointmenttime = row.appointmenttime
      this.formparams.canceltime = row.canceltime
      // this.formparams.timetype = row.timetype
      this.formparams.cancleTimeType = row.cancleTimeType
      this.formparams.type = this.type
      this.formparams.refundPercentage = row.refundPercentage
      this.formparams.ifApprove = row.ifApprove
      this.formparams.shopNum = row.shopnum


    },
    handleRemove(file) {
    },
    uploadFile(file){
      this.formData.append('uploadFile', file.file);
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          // // var appointmenttimeNum=''
          // var canceltimeNum = ''
          // if(this.formparams.timetype == 0){
          //   appointmenttimeNum = parseInt(this.formparams.appointmenttime*24*60)
          // } else if(this.formparams.timetype == 1){
          //   appointmenttimeNum = parseInt(this.formparams.appointmenttime*60)
          // } else{
          //   appointmenttimeNum = parseInt(this.formparams.appointmenttime)
          // }

          // if(this.formparams.cancleTimeType == 0){
          //   canceltimeNum = parseInt(this.formparams.canceltime*24*60)
          // } else if(this.formparams.cancleTimeType == 1){
          //   canceltimeNum = parseInt(this.formparams.canceltime*60)
          // } else{
          //   canceltimeNum = parseInt(this.formparams.canceltime)
          // }
          if(this.addType==1){
            tickeTinsertTbAppointConfig(this.formparams).then((res)=>{
              if(res.msg == 'success'){
                  this.dialogVisible = false
                  this.$message({
                    type:'success',
                    message:'添加成功'
                  })
                }
                this.getTableList()
            })
          } else {
            tickeTupdateTbAppointConfig(this.formparams).then((res)=>{
              if(res.msg == 'success'){
                  this.dialogVisible = false
                  this.$message({
                    type:'success',
                    message:'修改成功'
                  })
                }
                this.getTableList()
            })
          }
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
    remove(row){
      // ticketId
      this.$confirm('此操作将删除当前数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteTbAppointConfig({id:row.id}).then(res=>{
            if(res.msg == 'success'){
              this.$message({
                type:'success',
                message:'删除成功'
              })
              this.getTableList()
            }else{
              this.$message.error(res.data);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getTableList()
    },
  }
};
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// backticket.vue?09bc4588